import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagLow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.90909 2.90912C2.40701 2.90912 2 3.31613 2 3.81821V20.1818C2 20.6839 2.40701 21.0909 2.90909 21.0909C3.41117 21.0909 3.81818 20.6839 3.81818 20.1818V14.9546H21.0909C21.3994 14.9546 21.6869 14.7981 21.8544 14.539C22.0219 14.2799 22.0465 13.9536 21.9199 13.6723L19.7856 8.93185L21.9199 4.19142C22.0465 3.9101 22.0219 3.58375 21.8544 3.32467C21.6869 3.06558 21.3994 2.90912 21.0909 2.90912H2.90909Z",
		fill: "#FACA15"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.0365 12.5341C9.55255 12.5341 9.31055 12.2921 9.31055 11.8081V5.56011C9.31055 5.07611 9.54888 4.83411 10.0255 4.83411C10.5022 4.83411 10.7405 5.07611 10.7405 5.56011V11.2141H13.9635C14.4475 11.2141 14.6895 11.4341 14.6895 11.8741C14.6895 12.3141 14.4475 12.5341 13.9635 12.5341H10.0365Z",
		fill: "#111928"
	})]
});
export default SvgFlagLow;
